import { render } from "./RouteCompletedPage.vue?vue&type=template&id=ef9f9896&scoped=true"
import script from "./RouteCompletedPage.vue?vue&type=script&lang=js"
export * from "./RouteCompletedPage.vue?vue&type=script&lang=js"

import "./RouteCompletedPage.vue?vue&type=style&index=0&id=ef9f9896&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef9f9896"]])

export default __exports__